import { ThemeProvider } from "@emotion/react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import {
  createTheme,
  responsiveFontSizes,
  StyledEngineProvider,
} from "@mui/material";
import * as locales from "@mui/material/locale";
import PublicFormLayout from "./components/layouts/PublicFormLayout";

const App = () => {
  const theme = responsiveFontSizes(createTheme(locales["enUS"]));

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <PublicFormLayout />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
